invHdApp.
  factory('OrderMovement', ['$http', function ($http) {
    return {
      movement: function (data) {
        return $http.post('api/order-movement', data);
      },
      movementInit: function (data) {
        return $http.get('api/order-movement');
      },
      getBatch: function (data) {
        return $http.get('api/movement-batch', { params: data });
      }
    };
  }]);